import React from 'react';
import { useTranslation } from 'react-i18next';
import OptionModal from '../../../../components/modals/option-modal';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function SubmitConfirmationModal({
  onConfirm,
  onCancel,
}: Props) {
  const { t } = useTranslation();

  return (
    <OptionModal
      content={
        <p>{t('pages.crop.vaad_liz_reports_v2.list.modal.submit.approve')}</p>
      }
      buttons={[
        {
          title: t('pages.crop.vaad_liz_reports_v2.remove_modal.ok'),
          name: 'yes',
          value: 'yes',
        },
        {
          title: t('pages.crop.vaad_liz_reports_v2.remove_modal.cancel'),
          name: 'no',
          value: 'no',
        },
      ]}
      onChoice={(choice) => {
        if (choice === 'yes') {
          onConfirm();
        } else {
          onCancel();
        }
      }}
      onClose={onCancel}
    />
  );
}
